/**
 * Created by neo on 12.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { MindfulnessProgramTemplateDayUnitBuilder } from './MindfulnessProgramTemplateDayUnitBuilder';

export type MindfulnessProgramTemplateDay = {
  id: string;
  units: MindfulnessProgramTemplateDayUnit[];
  readonly minDurationInMinutes: number | undefined;
  readonly maxDurationInMinutes: number | undefined;
  toJS(newId?: boolean): MindfulnessProgramTemplateDay;
};

export function createMindfulnessProgramTemplateDay(json?: Partial<MindfulnessProgramTemplateDay>): MindfulnessProgramTemplateDay {
  return makeAutoObservable({
    id: json?.id ?? UUID(),
    units: (json?.units ?? []).map((u: any) => MindfulnessProgramTemplateDayUnitBuilder.build(u)),

    get minDurationInMinutes(): number | undefined {
      return this.units.reduce(
        (agg, cycle) =>
          cycle.durationInMinutes ? Math.min(cycle.durationInMinutes, agg ?? Number.MAX_SAFE_INTEGER) : agg,
        undefined as number | undefined,
      );
    },

    get maxDurationInMinutes(): number | undefined {
      return this.units.reduce(
        (agg, cycle) =>
          cycle.durationInMinutes ? Math.max(cycle.durationInMinutes, agg ?? Number.MIN_SAFE_INTEGER) : agg,
        undefined as number | undefined,
      );
    },

    toJS(newId: boolean = false): MindfulnessProgramTemplateDay {
      return {
        id: newId ? UUID() : this.id,
        units: this.units.map((u) => u),
      } as MindfulnessProgramTemplateDay;
    },
  });
}
